import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/report/board' : '/report/board'

export function infoData(data) {
  return request({
    url: urlPrefix + '/list',
    method: 'post',
    data
  })
}

export function empChange(data) {
  return request({
    url: urlPrefix + '/emp/change',
    method: 'post',
    data
  })
}

export function empAge(data) {
  return request({
    url: urlPrefix + '/emp/age',
    method: 'post',
    data: {
      type: 'emp',
      cusIds: data.cusIds
    }
  })
}

export function empHireTime(data) {
  return request({
    url: urlPrefix + '/emp/age',
    method: 'post',
    data: {
      type: 'company',
      cusIds: data.cusIds
    }
  })
}

export function salaryMonth(data) {
  return request({
    url: urlPrefix + '/emp/salary',
    method: 'post',
    data
  })
}

export function salaryType(data) {
  return request({
    url: urlPrefix + '/salary/type',
    method: 'post',
    data
  })
}

export function salaryDist(data) {
  return request({
    url: urlPrefix + '/salary/place',
    method: 'post',
    data
  })
}

export function deptSalary(data) {
  return request({
    url: urlPrefix + '/dept/salary',
    method: 'post',
    data
  })
}

export function costCenter(data) {
  return request({
    url: urlPrefix + '/costing',
    method: 'post',
    data
  })
}

export function salaryCompo(data) {
  return request({
    url: urlPrefix + '/salary/makeup',
    method: 'post',
    data
  })
}

export function nativePlace(data) {
  return request({
    url: urlPrefix + '/nativePlace',
    method: 'post',
    data
  })
}

/**
 * 查询当前登录人的可选集团客户
 * @param data
 */
export function boardGetCusList(data) {
  return request({
    url: urlPrefix + '/getCusList',
    method: 'post',
    data
  })
}

export function empEducation(data) {
  return request({
    url: urlPrefix + '/emp/edu',
    method: 'post',
    data: {
      type: 'emp',
      cusIds: data.cusIds
    }
  })
}

export function empGender(data) {
  return request({
    url: urlPrefix + '/emp/sex',
    method: 'post',
    data: {
      type: 'emp',
      cusIds: data.cusIds
    }
  })
}
